<template>
  <main id="selecionar-empresa" class="ohx login-modal">
    <v-content class="ohx">
      <v-container fluid grid-list-md class="white-background ohx">
        <v-layout row wrap>
          <v-flex xs12>
            <h2>Selecionar Tomador</h2>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-if="companies.length > 8"
              v-model="searchFilter.generalSearch"
              prepend-inner-icon="search"
              class="general-search mt-0 pt-0"
              height="6vh"
              solo
              label="Pesquise por nome ou CNPJ"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-list two-line>
              <template v-for="(item, index) in filteredItems">
                <v-list-tile
                  :key="item.title"
                  ripple
                  @click="$emit('click', item)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <strong>{{ maskCnpj(item.document) }}</strong>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      item.name
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < companies.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script lang="js">
import { maskCnpj, isValidCnpj } from "@/libs/utils";

export default {
  name: "SelecionarEmpresaModal",
  data: () => ({
    maskCnpj,
    searchFilter: {
      generalSearch: "",
    },
    alertText: false,
  }),

  computed: {
    filteredItems() {
      var t = this;
      let items = this.companies;

      let filters = this.searchFilter;

      if (items.length == 0) return [];

      if (!filters.generalSearch) {
        return items;
      }

      let tempItems = items;

      if (filters.generalSearch) {
        tempItems = tempItems.filter(
          (item) =>
            item.name
              .toLowerCase()
              .indexOf(filters.generalSearch.toLowerCase()) !== -1 ||
            (isValidCnpj(filters.generalSearch) &&
              item.document
                .toString()
                .indexOf(filters.generalSearch.replace(/[^\d]+/g, "")) !== -1)
        );
      }
      return tempItems;
    },
  },

  
  props: ["companies"],
};
</script>



// WEBPACK FOOTER //
// src/components/SelecionarEmpresaModal.vue